import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const whatsappMessage = encodeURIComponent(
    "Olá, vi o site da Lar do Eletro e gostaria de informações sobre conserto, peças ou utensílios."
  );
  const whatsappUrl = `https://wa.me/555132764130?text=${whatsappMessage}`;

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
           
            <p className="footer-description">
              Peças, consertos e utensílios para facilitar seu dia a dia.
            </p>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-title">Contato</h3>
            <div className="contact-info">
              <div className="contact-item">
        
                <span>R. José do Patrocínio, 40 – Porto Alegre, RS</span>
              </div>
           
              <div className="contact-item">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  (51) 3276-4130
                </a>
              </div>
            </div>
          </div>
          
          <div className="footer-section">
            <h3 className="footer-title">Links Úteis</h3>
            <div className="footer-links">
              <a href="/privacy" className="footer-link">Política de Privacidade</a>
              <a href="/terms" className="footer-link">Termos de Uso</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Lar do Eletro. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

